import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phara'
})
export class PharaPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    return value.substr(0,124)  ;
  }

}
